<div>
  <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
    <p>
      {{ "module-assignment.shirtPrint.modelConfiguration" | translate }}
    </p>
    <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
      <mat-slide-toggle
        [(ngModel)]="status"
        id="ebasketSalesSetupShirtPrintingModel"
        (change)="toggleEbasketSalesSetupModel()"
      >
      </mat-slide-toggle>
    </div>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutGap="20px grid"
    *ngIf="status"
    class="u-margin-top-15 u-margin-bottom-15"
  >
    <div fxFlex="100">
      <mat-card>
        <!-- <mat-card-header>
          <mat-card-title>
            {{ "module-assignment.shirtPrint.modelConfiguration" | translate }}
          </mat-card-title>
        </mat-card-header> -->
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
            [formGroup]="parentForm"
          >
            <div id="frmShirtModel" fxFlex="100" [formGroupName]="frmShirtModel">
              <div
                fxLayout="row wrap"
                fxLayoutGap="20px grid"
                class="u-margin-top-15 u-margin-bottom-15"
              >
                <div fxFlex="30">
                  <mat-form-field class="mat-block" floatLabel="never">
                    <input
                      matInput
                      formControlName="addVersionURL"
                      [placeholder]="
                  'module-assignment.shirtPrint.addVersionURL' |
                  translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div
                fxLayout="row wrap"
                fxLayoutGap="20px grid"
                class="u-margin-top-15 u-margin-bottom-15"
              >
                <div fxFlex="30">
                  <mat-form-field class="mat-block" floatLabel="never">
                    <input
                      matInput
                      formControlName="modelName"
                      [placeholder]="
                    'module-assignment.shirtPrint.modelName' |
                    translate"
                    />
                  </mat-form-field>
                </div>

                <div fxFlex="30">
                  <mat-form-field class="mat-block" floatLabel="never">
                    <input
                      matInput
                      formControlName="modelURL"
                      [placeholder]="
                    'module-assignment.shirtPrint.modelURL' |
                    translate"
                    />
                  </mat-form-field>
                </div>

                <div fxFlex="30">
                  <button
                    mat-flat-button
                    class="pull-left"
                    color="primary"
                    [matTooltip]="'module-assignment.shirtPrint.add' | translate"
                    matTooltipPosition="above"
                    (click)="AddModelData()"
                    [disabled]="canAddModelData()"
                  >
                    {{ "module-assignment.shirtPrint.add" | translate }}
                    <!-- <mat-icon>add_circle</mat-icon> -->
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
            *ngIf="products.length>0"
          >
            <div fxFlex="100">
              <table mat-table #ebasketModelTable [dataSource]="productDataSource" matSort>
                <ng-container matColumnDef="modelName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.shirtPrint.modelName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="modelURL">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.shirtPrint.modelURL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.url}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.shirtPrint.action" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.delete' | translate"
                      matTooltipPosition="above"
                      (click)="removeRow(element)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: productColumns;"></tr>
              </table>

              <mat-paginator
                [length]="products.length"
                [pageSize]="pageSizeOptions[0]"
                [pageSizeOptions]="pageSizeOptions"
                [disabled]="products.length <= pageSizeOptions[0]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutGap="20px grid"
    *ngIf="!status"
    class="u-margin-top-15 u-margin-bottom-15"
  >
    <mat-error>
      {{"module-assignment.shirtPrint.versionURLRequired" | translate }}
    </mat-error>
  </div>
</div>
